import {Box} from '@mui/material';
import {useContext} from 'react';
import {Switch, Route, Redirect, useRouteMatch} from 'react-router-dom';
import {AuthContext} from '../../../../../contexts/auth/context';
import {AuthContextType} from '../../../../../contexts/auth/types';
import {ScreenPaths} from '../../../../../enums/screen-path';
import ApiDocsPartnerOfficeScreen from '../api-docs/api-docs.partner.screen';
import HomePartnerOfficeScreen from '../home/home.partner.screen';

export default function PartnerOffice() {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  // Routing
  let {path} = useRouteMatch();

  return (
    <Box>
      <Switch>
        <Route exact path={`${path}${ScreenPaths.Partner_Home}`}>
          <HomePartnerOfficeScreen />
        </Route>
        {authContext.state.session?.partnerProfile?.developer === true && (
          <Route exact path={`${path}${ScreenPaths.Partner_ApiDocs}`}>
            <ApiDocsPartnerOfficeScreen />
          </Route>
        )}

        {/** Default route */}
        <Route path={path}>
          <Redirect to={`${path}${ScreenPaths.Partner_Home}`} />
        </Route>
      </Switch>
    </Box>
  );
}
